import { useEffect, useState } from "react";
import { Globe, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import WebProfileEditor from "@/components/webprofile/WebProfileEditor";
import { COPPER } from "./VestaAuth";
import { getAs } from "./VestaViewAs";

const asParams = () => { const a = getAs(); return a ? { as: a.id } : {}; };

export const useWebProfileActive = (enabled) => {
  const [on, setOn] = useState(false);
  useEffect(() => { if (enabled) api.get("/vesta/web-profile", { params: asParams() }).then((r) => setOn(!!r.data.attivo)).catch(() => setOn(false)); }, [enabled]);
  return on;
};

export default function WebProfileDialog({ open, onOpenChange }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return;
    setD(null); setErr("");
    api.get("/vesta/web-profile", { params: asParams() }).then((r) => (r.data.attivo ? setD(r.data) : setErr("Servizio Web Profile non attivo: contatta Torri."))).catch((e) => setErr(e.response?.data?.detail || "Errore"));
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto border-neutral-800 bg-neutral-950 text-white" data-testid="vesta-wp-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-heading text-xl" style={{ color: COPPER }}><Globe className="h-6 w-6" />Web Profile</DialogTitle></DialogHeader>
        <p className="-mt-2 text-xs text-neutral-400">La tua pagina su torri.solar. Ogni modifica salvata va online subito.</p>
        {err ? <p className="text-sm text-red-400" data-testid="vesta-wp-error">{err}</p> : !d ? <Loader2 className="h-5 w-5 animate-spin" style={{ color: COPPER }} /> : <WebProfileEditor base="/vesta" params={asParams()} data={d} />}
      </DialogContent>
    </Dialog>
  );
}
